export default __webpack_public_path__ + "static/Careers_US_Internship_22-227bf338cd4e3760d74e9972d9200c9e.jpg";